import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';

import { fetchServiceTypes, fetchedServiceTypes } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

export function* getServiceTypesSaga() {
  const { getServiceTypes } = getAPI();
  const response: YieldOf<typeof getServiceTypes> = yield call(getServiceTypes);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedServiceTypes(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedServiceTypes(undefined, error));
  }
}

export default function* situationsSaga() {
  yield takeLatest(fetchServiceTypes.type, getServiceTypesSaga);
}
